module.exports = __webpack_public_path__ + "img/banner-venta-pack.4556bc4c.png";